//ONE TRUST CONSENT MIXA BRAND EMITTERS
export const OTConsentEmitters = {
  OTBazaarVoiceEmitter: 'OTBazaarVoiceEmitter',
  OTRatingsAndReviewsEmitter: 'OTRatingsAndReviewsEmitter',
  OTStoryStreamEmitter: 'OTStoryStreamEmitter',
};
